import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appHelper from '../../../helpers/appHelper';
import * as objectConstants from '../../../constants/objectConstants';

class PrototypeVideoScreen extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            locale: props.locale,
        };
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {

    }

    componentDidUpdate() {

    }

    render() {
        return (
            <div className="prototype video-object-wrapper-prototype">
                <div className="video-col single">
                    <div className="object-container">
                        <div className="video-object">
                            <div className={`video-thumbnail-wrapper play`}>
                                <img src={require(`../../../assets/images/placeholder/placeholder_thumbnail.jpg`)} alt=""/>
                                <div className="video-details">
                                    <h4 dangerouslySetInnerHTML={{__html: objectConstants.PROTOTYPE_TEXT_TITLE}}/>
                                    <div dangerouslySetInnerHTML={{__html: objectConstants.PROTOTYPE_TEXT}}/>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

PrototypeVideoScreen.propTypes = {
    locale: PropTypes.object,
};

PrototypeVideoScreen.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {};

}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, {}), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PrototypeVideoScreen);



/** WEBPACK FOOTER **
 ** ./src/components/objects/prototypeObjects/PrototypeVideoScreen.js
 **/